import React, { useState } from "react";
import { useOrder } from "../context/OrderContext";
import { Trash2, RefreshCw } from "lucide-react";

const TestPanel = () => {
  const { orders, addOrder, updateOrderStatus, removeOrder } = useOrder();
  const [isVisible, setIsVisible] = useState(false);

  const clearAllOrders = () => {
    if (
      window.confirm(
        "Are you sure you want to clear all orders? This cannot be undone."
      )
    ) {
      localStorage.removeItem("restaurant_orders");
      window.location.reload();
    }
  };

  const addTestOrder = () => {
    const testOrder = {
      customerName: "Test Customer",
      phone: "123-456-7890",
      tableNumber: "5",
      specialInstructions: "Test order for development",
      paymentMethod: "cash",
      items: [
        {
          id: "test-item-1",
          name: "Test Burger",
          price: 12.99,
          quantity: 1,
        },
        {
          id: "test-item-2",
          name: "Test Fries",
          price: 4.99,
          quantity: 2,
        },
      ],
      total: 22.97,
      restaurant: {
        id: "test-restaurant",
        name: "Test Restaurant",
        address: "123 Test St",
        phone: "555-0123",
      },
    };

    addOrder(testOrder);
  };

  const updateTestOrderStatus = (orderId, status) => {
    updateOrderStatus(orderId, status);
  };

  if (!isVisible) {
    return (
      <div className="fixed bottom-4 right-4">
        <button
          onClick={() => setIsVisible(true)}
          className="bg-red-600 text-white p-3 rounded-full shadow-lg hover:bg-red-700 transition-colors"
          title="Show Test Panel"
        >
          <RefreshCw className="w-5 h-5" />
        </button>
      </div>
    );
  }

  return (
    <div className="fixed bottom-4 right-4 bg-white border border-gray-300 rounded-lg shadow-lg p-4 max-w-sm">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-semibold text-gray-900">Test Panel</h3>
        <button
          onClick={() => setIsVisible(false)}
          className="text-gray-500 hover:text-gray-700"
        >
          ×
        </button>
      </div>

      <div className="space-y-3">
        <div className="text-sm text-gray-600">
          <p>
            <strong>Orders in localStorage:</strong> {orders.length}
          </p>
        </div>

        <div className="space-y-2">
          <button
            onClick={addTestOrder}
            className="w-full bg-blue-600 text-white px-3 py-2 rounded text-sm hover:bg-blue-700"
          >
            Add Test Order
          </button>

          <button
            onClick={clearAllOrders}
            className="w-full bg-red-600 text-white px-3 py-2 rounded text-sm hover:bg-red-700 flex items-center justify-center space-x-2"
          >
            <Trash2 className="w-4 h-4" />
            <span>Clear All Orders</span>
          </button>
        </div>

        {orders.length > 0 && (
          <div className="space-y-2">
            <p className="text-sm font-medium text-gray-700">
              Test Order Status:
            </p>
            {orders.slice(0, 3).map((order) => (
              <div
                key={order.id}
                className="flex items-center justify-between text-xs bg-gray-50 p-2 rounded"
              >
                <span>#{order.id.slice(-4)}</span>
                <div className="flex space-x-1">
                  <button
                    onClick={() => updateTestOrderStatus(order.id, "preparing")}
                    className="px-2 py-1 bg-blue-100 text-blue-800 rounded text-xs"
                  >
                    Prep
                  </button>
                  <button
                    onClick={() => updateTestOrderStatus(order.id, "ready")}
                    className="px-2 py-1 bg-green-100 text-green-800 rounded text-xs"
                  >
                    Ready
                  </button>
                  <button
                    onClick={() => updateTestOrderStatus(order.id, "completed")}
                    className="px-2 py-1 bg-gray-100 text-gray-800 rounded text-xs"
                  >
                    Done
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default TestPanel;




